import React from 'react';
import RegisterContainer from '../../../Containers/UserContainer/Register';

const RegisterScreen = () => {
  return <RegisterContainer />;
};

export default RegisterScreen;
